import React, { useEffect, useState } from 'react'
import { 
  IoAddOutline, 
  IoSettingsOutline,
  IoPeopleOutline,
  IoPersonAddOutline,
  IoRefreshOutline
} from 'react-icons/io5';
import { 
  FiEdit2, 
  FiEye, 
  FiUserPlus, 
  FiRefreshCw,
  FiUsers,
  FiShield,
  FiCheckCircle,
  FiXCircle,
  FiGrid,
  FiSearch,
  FiFilter,
  FiUser,
  FiMail,
  FiKey,
  FiLock,
  FiUnlock,
  FiAward,
  FiStar
} from "react-icons/fi";
import { MdOutlineAdminPanelSettings, MdOutlineVerified, MdOutlineBlock } from "react-icons/md";
import { TbEdit } from 'react-icons/tb';
import { AiOutlineEye } from 'react-icons/ai'; 
import CreateModal from './Modal/CreateModal';
import EditModal from './Modal/EditModal'; 
import { useDispatch, useSelector } from 'react-redux';
import { adminList, adminStatusUpdate, saveAdmin } from '../../Redux/adminSlice';
import Loader from '../../components/Loader/Loader';
import { toast } from 'react-toastify';
import AccessModal from './Modal/AccessModal';

const createFeilds = { name: '', roleType: "", email: "", password: "", permissions: [] }

const multiSelectOptions = [
  { value: 'dashboard_analytics', label: 'Dashboard Analytics' },
  { value: 'user_management', label: 'User Management' },
  { value: 'course_management', label: 'Course Management' },
  { value: 'sessiion_management', label: 'Session Management' },
  { value: 'community_management', label: 'Community Management' },
  { value: 'payement_moderation', label: 'Payment & Transactions' },
  { value: 'Ads_management', label: 'Ads Management' },
  { value: 'certificate_management', label: 'Certificate Management' },
  { value: 'reward_management', label: 'Reward Management' },
  { value: 'support_management', label: 'Support Management' },
  { value: 'notification_management', label: 'Notification Management' },
  { value: 'preference_management', label: 'Preference Management' },
  { value: 'admin_management', label: 'Admin Management' },
  { value: 'setting_management', label: 'Setting Management' },
];

const roleType = [
  { value: "super_admin", label: "Super Admin" },
  { value: "sub_admin", label: "Sub Admin" },
  { value: "admin", label: "Admin" },
]

function AdminMangment() {
  const dispatch = useDispatch()
  const selector = useSelector(state => state)
  const [isCreateAdminModal, setIsCreateAdminModal] = useState(false)
  const [isAdminEditModal, setIsAdminEditModal] = useState(false)
  const [isAccessModal, setIsAccessModal] = useState(false)
  const [inputData, setInputData] = useState(createFeilds)
  const [editData, setEditData] = useState(null)
  const [selectedRoleType, setSelectedRoleType] = useState('')
  const [error, setError] = useState({})
  const [accessData, setAccessData] = useState([]); 
  const [searchTerm, setSearchTerm] = useState('')
  const [roleFilter, setRoleFilter] = useState('all')

  const { adminSlice: { getAllAdminList = [], loading } } = selector ? selector : {}

  useEffect(() => {
    dispatch(adminList())
  }, [dispatch])

  // Filter admins based on search and role
  const filteredAdmins = getAllAdminList.filter(admin => {
    const matchesSearch = admin?.userName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          admin?.email?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesRole = roleFilter === 'all' || admin?.role === roleFilter;
    return matchesSearch && matchesRole;
  });

  // Calculate statistics
  const totalAdmins = getAllAdminList.length;
  const activeAdmins = getAllAdminList.filter(a => !a?.isDisable).length;
  const inactiveAdmins = getAllAdminList.filter(a => a?.isDisable).length;
  const superAdmins = getAllAdminList.filter(a => a?.role === 'super_admin').length;

  const handleCreateAdmin = () => { setIsCreateAdminModal(!isCreateAdminModal) }
  const toggleCreateModal = () => { setIsCreateAdminModal(!isCreateAdminModal); setInputData(createFeilds); setError(null); setSelectedRoleType('') }
  const handleCreateOnChange = (e) => {
    const { name, value } = e.target; setInputData({ ...inputData, [name]: value })
  }
  const handleMultiSelectChange = (selectedOptions) => {
    setInputData({ ...inputData, permissions: selectedOptions || [] });
    if (error?.permissions) {
      setError({ ...error, permissions: '' });
    }
  };
  const handleCreateSubmit = (e) => {
    e.preventDefault()
    let payload = {
      userName: inputData?.name,
      role: selectedRoleType.value,
      access: inputData?.permissions?.map(permission => permission.value),
      email: inputData.email,
      password: inputData.password
    }
    dispatch(saveAdmin({ Payload: payload })).then((res) => {
      if (res?.payload?.error) {
        toast.error(res?.payload?.message)
      } else {
        toast.success(res?.payload?.message || "Admin Created Successfully")
        setInputData(createFeilds)
        setSelectedRoleType("")
        setError({})
      }
    }).catch((err) => {
      console.log("Error", err)
    })
    setIsCreateAdminModal(false)
  }
  const handleEditAdmin = (data) => {
    setIsAdminEditModal(!isAdminEditModal)
    setEditData(data)
  }
  const toggleEditModal = () => { setIsAdminEditModal(!isAdminEditModal) }
  const handleRoleSelect = (data) => {
    setSelectedRoleType(data)
  }

  const handleEditSubmit = (editedData) => {
    dispatch(saveAdmin({ Payload: editedData }))
    setIsAdminEditModal(false);
  };
  const handleUpdateStatus = (data) => {
    let apiPayload = {
      id: data?._id
    }
    dispatch(adminStatusUpdate({ Payload: apiPayload }))
  }

  const handleAccessView = (user) => {
    setAccessData(user.access || []);
    setIsAccessModal(true);
  };

  // Get role badge color
  const getRoleBadgeColor = (role) => {
    switch (role) {
      case 'super_admin':
        return 'bg-purple-100 text-purple-700 border-purple-200';
      case 'sub_admin':
        return 'bg-blue-100 text-blue-700 border-blue-200';
      case 'admin':
        return 'bg-emerald-100 text-emerald-700 border-emerald-200';
      default:
        return 'bg-gray-100 text-gray-700 border-gray-200';
    }
  };

  // Get role icon
  const getRoleIcon = (role) => {
    switch (role) {
      case 'super_admin':
        return <FiStar className="w-3.5 h-3.5" />;
      case 'sub_admin':
        return <FiShield className="w-3.5 h-3.5" />;
      case 'admin':
        return <FiUser className="w-3.5 h-3.5" />;
      default:
        return <FiUser className="w-3.5 h-3.5" />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50/80">
      <Loader loading={loading} />

      {/* Header Banner */}
      <div className="bg-gradient-to-r from-[#855DF6] via-[#7B5CF6] to-[#715EFE] shadow-lg relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mt-20 animate-pulse"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full -ml-12 -mb-12 animate-pulse"></div>
        <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2 animate-pulse"></div>
        
        <div className="relative z-10 px-4 md:px-7 py-6 md:py-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="p-2.5 bg-white/20 rounded-xl backdrop-blur-sm shadow-lg">
                <MdOutlineAdminPanelSettings className="w-5 h-5 text-white md:w-6 md:h-6" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-white md:text-2xl dahboardFont tracking-tight">
                  Admin Management
                </h2>
                <p className="text-sm text-white/70 hidden sm:block">
                  Manage administrators and their permissions
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={handleCreateAdmin}
                className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-[#715EFE] bg-white rounded-lg hover:bg-gray-50 transition-all duration-200 shadow-lg hover:shadow-xl"
              >
                <FiUserPlus className="w-4 h-4" />
                <span className="hidden sm:inline">Create New Admin</span>
                <span className="sm:hidden">Add Admin</span>
              </button>
              {/* <div className="flex items-center gap-2 px-3 py-1.5 bg-white/20 rounded-full backdrop-blur-sm">
                <FiRefreshCw className="w-3.5 h-3.5 text-white/70" />
                <span className="text-xs text-white/80">
                  {new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                </span>
              </div> */}
            </div>
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-2 gap-3 mt-5 sm:grid-cols-4 md:gap-4">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-lg font-bold text-white uppercase md:text-lg">Total Admins</p>
                  <p className="text-xl font-bold text-white md:text-2xl mt-0.5">{totalAdmins}</p>
                </div>
                <div className="p-2 rounded-xl bg-blue-500/30 shadow-inner">
                  <FiUsers className="w-4 h-4 text-white md:w-5 md:h-5" />
                </div>
              </div>
            </div>
            {/* <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-[10px] font-medium text-white/60 uppercase tracking-wider">Active</p>
                  <p className="text-xl font-bold text-emerald-300 md:text-2xl mt-0.5">{activeAdmins}</p>
                </div>
                <div className="p-2 rounded-xl bg-emerald-500/30 shadow-inner">
                  <FiCheckCircle className="w-4 h-4 text-emerald-300 md:w-5 md:h-5" />
                </div>
              </div>
            </div> */}
            {/* <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-[10px] font-medium text-white/60 uppercase tracking-wider">Inactive</p>
                  <p className="text-xl font-bold text-rose-300 md:text-2xl mt-0.5">{inactiveAdmins}</p>
                </div>
                <div className="p-2 rounded-xl bg-rose-500/30 shadow-inner">
                  <FiXCircle className="w-4 h-4 text-rose-300 md:w-5 md:h-5" />
                </div>
              </div>
            </div> */}
            {/* <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-[10px] font-medium text-white/60 uppercase tracking-wider">Super Admins</p>
                  <p className="text-xl font-bold text-amber-300 md:text-2xl mt-0.5">{superAdmins}</p>
                </div>
                <div className="p-2 rounded-xl bg-amber-500/30 shadow-inner">
                  <FiStar className="w-4 h-4 text-amber-300 md:w-5 md:h-5" />
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <section className="px-3 py-4 -mt-4 md:px-6 lg:px-10 md:py-6">
        <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
          {/* Search and Filter Bar */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 p-4 md:p-5 border-b border-gray-100 bg-gradient-to-r from-gray-50/50 to-white">
            <div className="flex items-center gap-3">
              <div className="p-1.5 bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 rounded-lg">
                <FiGrid className="w-4 h-4 text-[#715EFE]" />
              </div>
              <div>
                <h3 className="text-sm font-semibold text-gray-700">Admin List</h3>
                <p className="text-xs text-gray-400 hidden sm:block">
                  {filteredAdmins.length} admins • {activeAdmins} active
                </p>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full sm:w-auto">
              {/* Search */}
              <div className="relative flex-1 sm:min-w-[200px]">
                <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                <input
                  type="text"
                  placeholder="Search by name or email..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#715EFE]/20 focus:border-[#715EFE] transition-all duration-200"
                />
              </div>
              {/* Role Filter */}
              <div className="relative">
                <select
                  value={roleFilter}
                  onChange={(e) => setRoleFilter(e.target.value)}
                  className="pl-3 pr-8 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#715EFE]/20 focus:border-[#715EFE] transition-all duration-200 appearance-none bg-white capitalize"
                >
                  <option value="all">All Roles</option>
                  {roleType.map(role => (
                    <option key={role.value} value={role.value} className="capitalize">
                      {role.label}
                    </option>
                  ))}
                </select>
                <FiFilter className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="overflow-x-auto">
            <table className="w-full table-fixed text-left">
              <thead>
                <tr className="bg-gray-50/80 text-xs font-semibold text-gray-500 uppercase tracking-wider border-b border-gray-100">
                  <th className="w-[200px] px-4 py-3 whitespace-nowrap">
                    <div className="flex items-center gap-1.5">
                      <FiUser className="w-3.5 h-3.5 text-gray-400" />
                      <span>Name</span>
                    </div>
                  </th>
                  <th className="w-[200px] px-4 py-3 whitespace-nowrap">
                    <div className="flex items-center gap-1.5">
                      <FiMail className="w-3.5 h-3.5 text-gray-400" />
                      <span>Email</span>
                    </div>
                  </th>
                  <th className="w-[130px] px-4 py-3 whitespace-nowrap">
                    <div className="flex items-center gap-1.5">
                      <FiShield className="w-3.5 h-3.5 text-gray-400" />
                      <span>Role</span>
                    </div>
                  </th>
                  <th className="w-[100px] px-4 py-3 whitespace-nowrap text-center">
                    <div className="flex items-center justify-center gap-1.5">
                      <FiEye className="w-3.5 h-3.5 text-gray-400" />
                      <span>Access</span>
                    </div>
                  </th>
                  <th className="w-[120px] px-4 py-3 whitespace-nowrap text-center">
                    <div className="flex items-center justify-center gap-1.5">
                      <FiCheckCircle className="w-3.5 h-3.5 text-gray-400" />
                      <span>Status</span>
                    </div>
                  </th>
                  <th className="w-[100px] px-4 py-3 whitespace-nowrap text-center">
                    <span>Actions</span>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {filteredAdmins.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="px-4 py-12 text-center">
                      <div className="flex flex-col items-center gap-3">
                        <div className="p-4 bg-gray-50 rounded-full">
                          <FiUsers className="w-10 h-10 text-gray-300" />
                        </div>
                        <p className="text-sm font-medium text-gray-500">No admins found</p>
                        <p className="text-xs text-gray-400">Try adjusting your search or filters</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  filteredAdmins.map((user) => (
                    <tr 
                      key={user._id} 
                      className="hover:bg-gray-50/70 transition-colors duration-150 group"
                    >
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-3">
                          <div className="flex-shrink-0 w-9 h-9 rounded-full bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 flex items-center justify-center">
                            <span className="text-sm font-bold text-[#715EFE]">
                              {user.userName?.charAt(0)?.toUpperCase() || 'A'}
                            </span>
                          </div>
                          <span className="text-sm font-semibold text-gray-800 truncate font-inter">
                            {user.userName || 'N/A'}
                          </span>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <span className="text-sm text-gray-600 truncate font-inter">
                          {user.email || 'N/A'}
                        </span>
                      </td>
                      <td className="px-4 py-3">
                        <span className={`
                          inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-full border
                          ${getRoleBadgeColor(user.role)}
                        `}>
                          {getRoleIcon(user.role)}
                          {user.role?.replace(/_/g, ' ') || 'N/A'}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-center">
                        <button
                          className="p-2 text-[#715EFE] hover:bg-[#715EFE]/10 rounded-lg transition-all duration-200"
                          onClick={() => handleAccessView(user)}
                          title="View Access"
                        >
                          <FiEye className="w-4 h-4" />
                        </button>
                      </td>
                      <td className="px-4 py-3 text-center">
                        <button
                          className={`
                            inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg transition-all duration-200
                            ${user?.isDisable
                              ? 'bg-rose-50 text-rose-600 hover:bg-rose-100 border border-rose-200'
                              : 'bg-emerald-50 text-emerald-600 hover:bg-emerald-100 border border-emerald-200'
                            }
                          `}
                          onClick={() => handleUpdateStatus(user)}
                        >
                          {user?.isDisable ? (
                            <>
                              <FiXCircle className="w-3.5 h-3.5" />
                              Inactive
                            </>
                          ) : (
                            <>
                              <FiCheckCircle className="w-3.5 h-3.5" />
                              Active
                            </>
                          )}
                        </button>
                      </td>
                      <td className="px-4 py-3 text-center">
                        <button
                          className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-white bg-[#715EFE] rounded-lg hover:bg-[#624BFF] transition-all duration-200 shadow-sm hover:shadow-md"
                          onClick={() => handleEditAdmin(user)}
                        >
                          <FiEdit2 className="w-3.5 h-3.5" />
                          <span className="hidden sm:inline">Edit</span>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Modals */}
      {isCreateAdminModal && (
        <CreateModal 
          onCancel={toggleCreateModal} 
          title={"Create Admin"} 
          inputData={inputData} 
          handleONChange={handleCreateOnChange} 
          onSubmit={handleCreateSubmit} 
          multiSelectOptions={multiSelectOptions} 
          handleMultiSelectChange={handleMultiSelectChange} 
          error={error} 
          roleType={roleType}
          handleRoleSelect={handleRoleSelect} 
          selectedRoleType={selectedRoleType} 
        />
      )}

      {isAdminEditModal && (
        <EditModal
          onCancel={toggleEditModal}
          onSubmit={handleEditSubmit}
          inputData={editData}
          multiSelectOptions={multiSelectOptions}
          roleType={roleType}
        />
      )}

      {isAccessModal && (
        <AccessModal
          onCancel={() => setIsAccessModal(false)}
          accessData={accessData}
        />
      )}
    </div>
  )
}

export default AdminMangment;